// components/templates/sections/CTA_BAND_COFFEE.tsx
import React from "react";
import { useDesign } from "@/context/DesignContext";

type CtaProps = { title?: string; subtitle?: string; buttonText?: string; design?: any };

export default function CTA_BAND_COFFEE({ title = "Come taste for yourself", subtitle = "Visit our locations", buttonText = "Find a cafe", design: propDesign }: CtaProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;

  const primaryColor = design?.colors?.primary || "#C8622A";
  const secondaryColor = design?.colors?.secondary || "#E8A45A";
  const bgColor = design?.colors?.background || "#0C0500";
  const textColor = design?.colors?.text || "#F5E6D3";
  const textLightColor = design?.colors?.textLight || "#BFA76A";

  return (
    <section className="py-24 relative overflow-hidden">
      <div className="absolute inset-0" style={{ background: `linear-gradient(to right, ${primaryColor}33, transparent)` }} />
      <div className="relative max-w-7xl mx-auto px-8 text-center">
        <h2 className="font-display text-5xl md:text-6xl font-black mb-4" style={{ color: textColor }}>{title}</h2>
        <p className="text-xl mb-8" style={{ fontStyle: "italic", color: `${textLightColor}99` }}>{subtitle}</p>
        <button className="font-mono-custom text-sm tracking-widest uppercase px-10 py-4 transition-all duration-300 hover:scale-105"
                style={{
                  backgroundColor: primaryColor,
                  color: bgColor,
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = secondaryColor}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = primaryColor}>
          {buttonText}
        </button>
      </div>
    </section>
  );
}